// 解析一级菜单URL
const parseFirstMenuUrl = (menuUrl) => {
  const regex =
    /(?:rss-menu:\/\/)(?<category>\w+)(?:\|(?<position>[^|.]+))?(?:\|(?<url>.+))?/gi;
  const {
    groups: { category, position, url },
  } = regex.exec(menuUrl);
  return { category, position, url };
};

// 解析二级菜单URL
const parseSecondMenu = (item, parentId = -1) => {
  const { title, type, id, url } = item;
  // 上线稳定之后，删除这段代码，联系权限组刷菜单（灯塔菜单加上/courier
  let newUrl = null;
  if (url.startsWith("/finance")) {
    newUrl = url;
  } else if (url.startsWith("/material/material")) {
    newUrl = url.replace(/\/material(?=\/)/, "/materials");
  } else {
    newUrl = `/courier${url}`;
  }
  const formattedItem = {
    ...item,
    id: `${id}`,
    // 新增
    level: 2,
    parentId,
    target: type === 1 ? "_self" : "_blank",
    text: title,
    url: newUrl,
  };
  return formattedItem;
};

export const formatMenuSource = (menuList = []) => {
  let formattedData = [];
  const filteredRSSMenu = (menuList || []).filter(
    (item) => item.url.indexOf("rss-menu://") >= 0
  );
  for (const item of filteredRSSMenu) {
    const { category, position, url } = parseFirstMenuUrl(item.url);
    const { secondaryMenus, id, title, type, ...rest } = item;
    const children =
      secondaryMenus && secondaryMenus.length
        ? secondaryMenus.map((cItem) => parseSecondMenu(cItem, id))
        : [];
    const firstMenu = {
      ...rest,
      id: `${id}`,
      title: title.replace("灯塔-", ""),
      type,
      url: url?.slice(1) || url,
      // 新增
      level: 1,
      category,
      children,
      position: position || "left",
      isLeaf: url?.startsWith("|"),
      target: type === 1 ? "_self" : "_blank",
      text: title,
      iconUrl: (menuIcon?.[item.url] || menuIcon.default).default,
    };
    if (firstMenu.children.length > 0) {
      formattedData.push(firstMenu);
    }
  }
  return formattedData;
};

export const getActiveMenu = (menuList, pathname) => {
  const activeItem = {
    defaultActive: "",
    defaultExpandedNames: [],
  };
  const path = pathname.replace(".html", "");
  if (path === "/") return activeItem;
  menuList.forEach((firstMenu) => {
    if (firstMenu.url === path) {
      activeItem.defaultActive = firstMenu.id;
      activeItem.defaultExpandedNames.push(firstMenu.id);
    }
    firstMenu.children.forEach((secondMenu) => {
      if (secondMenu.url === pathname) {
        activeItem.defaultActive = secondMenu.id;
        activeItem.defaultExpandedNames.push(firstMenu.id);
      }
    });
  });
  return activeItem;
};

export const menuIcon = {
  // 骑手管理
  "rss-menu://dengta/qishouguanli": {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/8144066e5f9130c52841d5be433a80b2643.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/573f3fd6ca2380251c226d6791395262530.png",
  },
  // 配送看板
  "rss-menu://dengta/peisongkanban": {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/d3354978f01b78f9e74e333c84ede74a651.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/d834b0476dab2eda8e28c0b82668d565543.png",
  },
  // 骑手排班/考勤
  "rss-menu://dengta/qishoupaiban": {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/853b553a6d65753f77f7d294fb92af351051.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/324f5d361766e9ee7a18e6a60fcabde1850.png",
  },
  // eHR
  "rss-menu://dengta/ehr": {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/7dd62d9f16f0744ad6a72469863e735d1273.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/0e11d4d78be9e4711470f2e72be7cf37961.png",
  },
  // 站点管理
  "rss-menu://dengta/siteManagement": {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/0f1bad661ebc87797cbd492e44cf48801330.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/09a3f4b2c4c05d41151198e7d03e385f917.png",
  },
  // 通知中心
  "rss-menu://dengta/tongzhizhongxin": {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/9b0819d689d6ca19c3b733c075af9ace837.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/4644987d625843bca8902c2446ddfafe642.png",
  },
  // 默认兜底
  default: {
    default:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/d48bbfecb1d272b65595d00c6a8ea660494.png",
    select:
      "https://img-ap-hongkong.mykeeta.net/osgeujiemo/7ede339d627f6d40f9799fe01fd729dc405.png",
  },
};
